// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon{display:inline-block;height:1em;stroke-width:0;stroke:currentColor;fill:currentColor}.icon,.icon-search{width:1em}.icon-menu{width:1.6em}.icon-close{font-size:1.5em}", ""]);
// Exports
module.exports = exports;
